/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React, { ReactElement } from "react";
import { createGlobalStyle } from "styled-components";

import { WindowMeasureContext } from "~/contexts";
import { useWindowMeasure } from "~/hooks";
import { PDFPage } from "~/pages";
import { analytics } from "~/utils";

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    margin: 0px;
    padding: 0px;
    touch-action: pan-x pan-y;
  }

  .pdf-loading {
    display: none;
  }
`;

// TODO pdf-loading class shouldnt live here if pdf is to be reusable

export default function App(): ReactElement {
  const args = window.location.pathname.split("/");
  const pdfName = args[1] ? args[1] : "offer";

  const query = new URLSearchParams(window.location.search);
  const uQuery = query.get("u");
  const userId = uQuery !== null ? uQuery : undefined;

  analytics.init(pdfName, userId);

  // TODO once we log user into analytics we should remove userId from slug so when it's share there's no dirty data

  const windowMeasure = useWindowMeasure();

  return (
    <>
      <GlobalStyles />

      <WindowMeasureContext.Provider value={windowMeasure}>
        {pdfName ? <PDFPage pdfName={pdfName} /> : "Invalid document"}
      </WindowMeasureContext.Provider>
    </>
  );
}
